import React from 'react';
import { useLoruleAuth } from '../hooks/useLoruleAuth';
import { useLoruleNav } from '../hooks/useLoruleNav';
import BaseLoruleApplication from './BaseLoruleApplication';

var LoruleApplication = function LoruleApplication(_ref) {
  var authCallback = _ref.authCallback,
      tabs = _ref.tabs,
      routes = _ref.routes,
      appName = _ref.appName,
      defaultPath = _ref.defaultPath,
      logoutCustom = _ref.logoutCustom,
      loadingCustom = _ref.loadingCustom,
      userDropDownItems = _ref.userDropDownItems,
      dropDownMenus = _ref.dropDownMenus,
      userConfig = _ref.userConfig,
      navHeaderCustom = _ref.navHeaderCustom;
  var authState = useLoruleAuth(authCallback);

  var _useLoruleNav = useLoruleNav(tabs, routes, userConfig),
      menuTabs = _useLoruleNav.tabs,
      allRoutes = _useLoruleNav.routes,
      configComponent = _useLoruleNav.configComponent;

  return /*#__PURE__*/React.createElement(BaseLoruleApplication, {
    authState: authState,
    tabs: menuTabs,
    routes: allRoutes,
    appName: appName,
    defaultPath: defaultPath,
    userConfig: configComponent,
    navHeaderCustom: navHeaderCustom,
    logoutCustom: logoutCustom,
    loadingCustom: loadingCustom,
    userDropDownItems: userDropDownItems,
    dropDownMenus: dropDownMenus
  });
};

export default LoruleApplication;